__turbopack_context__.v({
  "horizontal": "Stack-module__wjzJMa__horizontal" + " " + "Stack-module__wjzJMa__stack",
  "stack": "Stack-module__wjzJMa__stack",
  "vertical": "Stack-module__wjzJMa__vertical" + " " + "Stack-module__wjzJMa__stack",
});
